import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Alert, Button } from 'react-bootstrap';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
    notice: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
        padding: theme.spacing(2.5, 3),
        margin: theme.spacing(2),
        maxWidth: 720,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    title: {
        fontWeight: 600,
        fontSize: '1.1rem',
        marginBottom: 0,
    },
    bodyText: {
        marginBottom: 0,
    },
}));

const MergedRecordNotice = ({ customer, masterCustomerCode }) => {
    const classes = useStyles();
    const customerName = useMemo(() => (
        `${customer?.firstName || ''} ${customer?.lastName || ''}`.trim() || `Customer ${customer?.customerCode}`
    ), [customer]);

    return (
        <Alert variant="info" className={classes.notice}>
            <div className={classes.header}>
                <InfoOutlinedIcon color="primary" />
                <h5 className={classes.title}>
                    This customer record has been merged
                </h5>
            </div>
            <p className={classes.bodyText}>
                {`${customerName} (ID: ${customer?.customerCode}) is read-only because it was merged into another customer.`}
            </p>
            {masterCustomerCode && (
                <Button
                    as={RouterLink}
                    variant="primary"
                    to={`/customers/${masterCustomerCode}`}
                >
                    {`Go to Master Customer #${masterCustomerCode}`}
                </Button>
            )}
        </Alert>
    );
};

MergedRecordNotice.propTypes = {
    customer: PropTypes.object.isRequired,
    masterCustomerCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MergedRecordNotice.defaultProps = {
    masterCustomerCode: null,
};

export default MergedRecordNotice;
